<script setup lang="ts">
import TariffPage from "@/components/tariff/TariffPage.vue";
</script>

<template>
  <TariffPage />
</template>

<style scoped lang="scss"></style>
